// A dry desert shrub: a small, sparse tangle of pale-brown twigs with a little
// dusty-green foliage — scrubby and low. Ported 1:1 from age-of-mcp's classic
// dry-shrub.ts, restoring its radial twig loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  const N = 5;
  for (let i = 0; i < N; i++) {
    const a = (i / N) * Math.PI * 2;
    parts.push({
      geometry: new THREE.CylinderGeometry(0.012, 0.02, 0.3, 4),
      color: "#9c7f4e",
      position: [Math.cos(a) * 0.08, 0.15, Math.sin(a) * 0.08],
      rotation: [Math.sin(a) * 0.5, 0, Math.cos(a) * 0.5],
    });
  }
  parts.push({ geometry: new THREE.IcosahedronGeometry(0.13, 0), color: "#8a9460",
    position: [0, 0.26, 0] });
  return parts;
}

export const dryShrub = defineModel({
  id: "dry-shrub",
  batchId: "standard",
  name: "Dry shrub",
  tags: ["scenery","dry","shrub","low-poly","age-of-mcp","classic"],
  summary: "Low-poly dry shrub.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => partsFor(),
  animations: [],
});
